import { Formik, FormikHelpers } from 'formik'
import { Button, InputField, Modal } from '../../../../components'
import { addBrand } from '../../slice/brandSlice'
import { useAppDispatch } from '../../../../redux/hook'
import { addBrandSchema } from '../../schema'
import { useTranslation } from 'react-i18next'
interface AddModalProps {
    show: boolean
    onClose: (value: boolean) => void
}
interface addBrandFormValues {
    name: string
    description: string
}
const AddBrand = ({ show, onClose }: AddModalProps) => {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()
    return (
        <Modal
            show={show}
            handleClose={() => onClose(false)}
            title={t('brand.brandModals.addModalTitle')}
            body={
                <Formik
                    initialValues={{
                        name: '',
                        description: '',
                    }}
                    validationSchema={addBrandSchema}
                    onSubmit={(
                        values,
                        actions: FormikHelpers<addBrandFormValues>
                    ) => {
                        dispatch(addBrand(values))
                        actions.setSubmitting(false)
                        onClose(false)
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <InputField
                                type="text"
                                name="name"
                                lable="Brand name"
                                value={values.name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.name}
                                touched={touched.name}
                            />
                            <InputField
                                type="text"
                                name="description"
                                lable="Description"
                                value={values.description}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.description}
                                touched={touched.description}
                            />
                            <Button disabled={isSubmitting} type="submit">
                                {t('button.add')}
                            </Button>
                        </form>
                    )}
                </Formik>
            }
            onSuccess={() => {
                onClose(false)
            }}
        />
    )
}
export default AddBrand
